
<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-form ref="form">
      <v-layout wrap justify-center>
        <v-flex xs12 class="head2"> Profile Picture </v-flex>
        <v-flex xs12>
          <v-img
            v-if="profileData.photo == null"
            width="300px"
            contain
            class="mx-auto"
            src="../../../../assets/images/no-image.png"
          >
            <Propic
              @stepper="profilewinStepper"
              :height="'811'"
              :width="'811'"
              :heading="'Upload Profile Picture'"
              :componentType="'coverImage'"
            />
          </v-img>
          <v-img
            v-else
            width="300px"
            contain
            class="mx-auto"
            :src="profileData.photo"
          >
            <Propic
              @stepper="profilewinStepper"
              :height="'811'"
              :width="'811'"
              :heading="'Upload Profile Picture'"
              :componentType="'coverImage'"
            />
          </v-img>
        </v-flex>

        <v-flex xs12 py-5 class="head2" text-left> Contact information </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-account-outline"
            v-model="profileData.shopName"
            label="Shop  Name"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            type="number"
            :rules="[rules.required]"
            prepend-icon="mdi-phone-outline"
            v-model="profileData.phone"
            label="Phone"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.email]"
            prepend-icon="mdi-at"
            v-model="profileData.email"
            label="Email"
          >
          </v-text-field>
        </v-flex>

        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-account-outline"
            v-model="profileData.contactPerson"
            label="Contact Person"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-map-marker-outline"
            v-model="profileData.place"
            label="Place"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-map-marker-outline"
            v-model="profileData.pincode"
            label="Pincode"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-map-marker-outline"
            v-model="profileData.city"
            label="City"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pl-3>
          <v-text-field
            :rules="[rules.required]"
            prepend-icon="mdi-pencil-outline"
            v-model="profileData.description"
            label="Description"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 py-4 text-left>
          <span class="head2">Social media links</span>
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <v-text-field
            prepend-icon="mdi-facebook"
            v-model="profileData.facebook"
            label="facebook"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <v-text-field
            prepend-icon="mdi-instagram"
            v-model="profileData.instagram"
            label="Instagram"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm4 px-2>
          <v-text-field
            prepend-icon="mdi-whatsapp"
            v-model="profileData.whatsapp"
            label="whatsapp"
          >
          </v-text-field>
        </v-flex>

        <v-flex xs12 pb-7 pt-3 text-left>
          <span class="head2">Select location</span>
        </v-flex>
        <v-flex xs12>
          <div id="map44"></div>
        </v-flex>

        <!-- <v-flex xs12 sm6 pl-3 py-12>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center pb-4>
            <span class="head">Upload to Hive Gallery</span>
          </v-flex>
          <v-flex xs12 sm6 md12 text-center v-if="flag">
            <galleryComp
              @stepper="galleryStepper"
              :photos="urlgallery"
              :pageId="$route.query.seller"
              :details="urlgallery"
              :sellerId="$route.query.seller"
              :height="'5118'"
              :width="'8001'"
              :heading="'Upload Images'"
              :componentType="'coverImage'"
            />
          </v-flex>
        </v-layout>
      </v-flex> -->
        <v-flex xs12 md6 text-center py-7>
          <v-btn tile width="100%" dark color="#FEBD08" @click="profileUpdate">
            save</v-btn
          >
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBaUVPtkwXGFXPy05pSXVx0Y7QmGj-P-ls&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
import Propic from "./profileImage";

export default {
  components: {
    Propic,
  },
  props: ["sellerData", "id"],
  data() {
    return {
      lat: 0,
      lon: 0,
      sample: null,
      tab: null,
      changedlat: null,
      changedlon: null,
      sp: [],
      timeout: 3000,
      video: [],
      videoData: new FormData(),
      urlgallery: [],
      url7: [],
      marker: [],
      msg: "",
      maps: null,
      showSnackBar: false,
      showCoverImage: "",
      coverImage: "",
      coverData: new FormData(),
      appLoading: false,
      hiveGallery: [],
      gallery: new FormData(),
      heading: "",
      description: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      apiary: "",
      videoURL: "",
      displayName: "",
      keeperDescription: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      imageFiles: [],
      imageArray: [],
      flag: true,
      profileImage: null,
      pic2: null,
      form: new FormData(),
    };
  },
  computed: {
    profileData() {
      if (this.sellerData) {
        return this.sellerData;
      } else return {};
    },
  },
  mounted() {
    this.getUser();
    // this.marker.setMap(null);
    this.marker = new google.maps.Marker({
      position: { lat: this.lat, lng: this.lon },
      map: this.maps,
      title: "Hello World!",
    });
  },

  methods: {
    profilewinStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.profileImage = window_data.selectedFiles;
        this.profileData.photo = window_data.img;
      }
    },
    // watch: {
    //   profileData: {
    //   handler(val) {
    //     if (val.lat > 0) {
    //             this.getMap();
    //             console.log("just for testing")

    //     }

    //   },
    //    deep: true,
    //   }

    // },
    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;
        // console.log("cover image is", this.coverImageFile);
        this.coverImageUpload();
      }
    },
    galleryStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        this.imageFiles.splice(window_data.removalItem, 1);
        this.imageArray = window_data.imageArray;
      } else if (window_data.type == "imageDeletion") {
        if (window_data.response.status) this.getUser();
      }
      if (window_data.getData) {
        this.getUser();
      }
    },
    getMap() {
      // console.log("latttttt", this.lat)
      // console.log("lonnnnn", this.lon)
      const gmap = new google.maps.Map(document.getElementById("map44"), {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
      });
      this.maps = gmap;
      google.maps.event.addListener(this.maps, "click", (e) => {
        this.mark(e);
      });
      // this.marker = new google.maps.Marker({
      //   map: this.maps,
      //   title: "Hello World!",
      // });
    },
    mark(event) {
      //  console.log("we r in")

      this.lat = null;
      this.lon = null;
      // console.log("the map  valuee is=",this.lon)
      this.marker.setMap(null);
      this.lat = event.latLng.lat();
      this.lon = event.latLng.lng();

      // this.changedlat = this.latt;
      // this.changedlon =   this.lonn ;
      // console.log("marked lat is",  this.profileData.changedlat);
      // console.log("marked lon is", this.profileData.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lon },
        map: this.maps,
        title: "Hello World!",
      });
      // console.log("marker =", this.latt);
    },
    unselect(value, item) {
      this.hiveGallery.splice(value, 1);
      this.urlgallery.splice(value, 1);
      this.sp = item;
      // console.log("the image name is", this.sp);
      this.deleteFomGallery(item);
    },
    chooseCoverImage() {
      document.getElementById("coverImage").click();
    },
    browseToGallery(img) {
      for (let i = 0; i < img.length; i++) {
        this.hiveGallery.push(img[i]);
        this.url7.push(URL.createObjectURL(this.hiveGallery));
      }

      // this.hiveGallery = file.target.files;
      // console.log("gallery is", this.hiveGallery);
      // console.log("hive gallary is=", this.hiveGallery);
      // this.uploadToGallery()
    },

    coverImageUpload() {
      this.coverData.append("uid", this.$route.query.seller);
      this.coverData.append("coverImage", this.coverImage);

      axios({
        method: "post",
        url: "/seller/coverImage/upload",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.coverData,
      }).then((response) => {
        if (response.data.status) {
          this.showCoverImage = response.data.coverImage;
          this.coverData = new FormData();
        } else {
          alert("failed to update cover image");
        }
      });
    },

    profileUpdate() {
      this.appLoading = true;
      this.profileData.id = this.$route.query.seller;
      this.profileData.lat = this.lat;
      this.profileData.lon = this.lon;
      let getURL;
      if (this.$route.query.Type == "foodSeller") {
        getURL = "/admin/seller/edit";
      }
      if (this.$route.query.Type == "grocerySeller") {
        getURL = "/grocery/admin/seller/edit";
      }
      axios({
        method: "post",
        // url: "/admin/seller/edit",
        url: getURL,

        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.profileData,
      }).then((response) => {
        this.profilePicUpdate();

        if (response.data.status) {
          // this.$emit("stepper", {
          //   getData: true,
          // });
          this.showSnackBar = true;
          this.msg = response.data.msg;
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
        this.appLoading = false;
      });
    },
    profilePicUpdate() {


      let getURL;
      if (this.$route.query.Type == "foodSeller") {
        getURL = "/admin/seller/edit";
      }
      if (this.$route.query.Type == "grocerySeller") {
        getURL = "/grocery/admin/seller/edit";
      }

      // this.profileData.photo =null,
      this.form.append("uid", this.$route.query.seller);
      this.form.append("photo", this.profileImage);
      axios({
        method: "post",
        url: getURL,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.form,
      }).then((response) => {
        if (response.data.status) {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
      });
    },

    //new line of codes

    getUser() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          if (this.$route.query.Type == "foodSeller") {
            this.lat = response.data.data.sellerid.location[1];
            this.lon = response.data.data.sellerid.location[0];
          }

          if (this.$route.query.Type == "grocerySeller") {
            this.lat = response.data.data.grocerySellerId.location[1];
            this.lon = response.data.data.grocerySellerId.location[0];
          }

          console.log(this.lat, "this is our lat ");
          this.getMap();
          this.marker = new google.maps.Marker({
            position: { lat: this.lat, lng: this.lon },
            map: this.maps,
          });
        } else {
          this.appLoading = false;

          alert("failed to get email");
        }
      });
    },
  },
};
</script>

<style >
.center >>> input {
  text-align: center;
  font-family: robotobold;
}
.v-text-field >>> label {
  font-family: robotoregular;
  color: #d5d5d5;
}
#map44 {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
